module.exports = __webpack_public_path__ + "media/apps/main/containers/portfolio/Export/Docx/helpers/SdgIcons/assets/sdg1-78cff0bd8e23daeeb018c5e10deb5b1c.svg";